
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatasourceDownstreamMetricsQueryVariables, DatasourceDownstreamMetricsQuery, MetricsDisplayGridRowDataFragment, DownstreamMetricsFilteredByFieldQueryVariables, DownstreamMetricsFilteredByFieldQuery, MetricSortOrder , DatasourceDownstreamMetricsDocument , DownstreamMetricsFilteredByFieldDocument } from '../../../../../gen-src/queries';
import {
  ConnectionListResult,
  GridSortProps,
  PaginatedQueryWrapper
} from '../../../data-catalog-shared';
import { getRowDataForMetric, MetricsDisplayGrid, MetricsDisplayGridRowData } from '../sharedDisplayGrid/MetricsDisplayGrid';
import { MetricsValidSortFields } from '../sorting/sortProviders/MetricsGridSortProvider';

type QueryVariables = DatasourceDownstreamMetricsQueryVariables;
type QueryResults = DatasourceDownstreamMetricsQuery;
type QueryResultListNode = MetricsDisplayGridRowDataFragment;
type GridRowData = MetricsDisplayGridRowData;

type QueryVariablesWithFilter = DownstreamMetricsFilteredByFieldQueryVariables;
type QueryResultsWithFilter = DownstreamMetricsFilteredByFieldQuery;

function selectConnectionListResult(resultData: QueryResults): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.publishedDatasources && resultData.publishedDatasources[0] &&
    resultData.publishedDatasources[0].downstreamMetricsConnection;
}

// TODO: jschneidereit verify
function selectConnectionListResultForFilteredQuery(resultData: QueryResultsWithFilter): ConnectionListResult<QueryResultListNode> | null {
  return resultData.fieldsConnection.nodes?.[0]?.downstreamMetricsConnection;

  // return resultData && resultData.fieldsConnection && resultData.fieldsConnection.nodes &&
  //   resultData.fieldsConnection.nodes[0] && getMetricsConnection(resultData.fieldsConnection.nodes[0]);
}

// function getMetricsConnection(field: DownstreamMetricsFilteredByFieldQuery_fieldsConnection_nodes) {
//   return 'downstreamMetricsConnection' in field ? field.downstreamMetricsConnection : null;
// }

export type DatasourceDownstreamMetricsQueryGridProps =
  GridSortProps<MetricsValidSortFields> & {
    readonly vizportalUrlId: string;
    readonly filteredFieldId: string | null;
    readonly rowCount: number | null;
  };

export function DatasourceDownstreamMetricsQueryGrid(props: DatasourceDownstreamMetricsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyDownstreamMetricsLineageGridMessage();
  const emptyFilteredGridMessage = Messages.EmptyDownstreamFilteredMetricsLineageGridMessage();

  return (
    props.filteredFieldId ? (
      // Query with Selected Field as Filter
      <PaginatedQueryWrapper<QueryVariablesWithFilter, QueryResultsWithFilter, QueryResultListNode, GridRowData>
        queryGql={DownstreamMetricsFilteredByFieldDocument}
        partialQueryVariables={{ selectedFieldId: props.filteredFieldId, orderBy: props.orderBy as MetricSortOrder }}
        selectConnectionListResult={selectConnectionListResultForFilteredQuery}
        mapResultNode={getRowDataForMetric}
      >
        {({ rowStore }) => <MetricsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyFilteredGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    ) : (
      // Query without Selection
      <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
        queryGql={DatasourceDownstreamMetricsDocument}
        partialQueryVariables={{ vizportalUrlId: props.vizportalUrlId, orderBy: props.orderBy as MetricSortOrder }}
        selectConnectionListResult={selectConnectionListResult}
        mapResultNode={getRowDataForMetric}
      >
        {({ rowStore }) => <MetricsDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          orderBy={props.orderBy}
          updateSortOrder={props.updateSortOrder}
        />}
      </PaginatedQueryWrapper>
    )
  )
}
